import { uomDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import { FieldType, IFieldValue, InputField } from "veronica-ui-component/dist/component/core";

export const ChangeQtyUomAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();

    const hideUom = useMemo(() => {
        const includeTypes = ['CSR_ST', 'CSR_DEL', 'CSR_PC',];
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const ret = chargeTypeList.some(type => includeTypes.includes(type));
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <InputField
                        label='Charge Qty'
                        width='150px'
                        type="number"
                        value={chargeBatchUpdate.qty || ''}
                        onChange={(e) => chargeDetailVM.onInputTextChange(e, 'qty', chargeBatchUpdate, 'chargeBatchUpdate')}
                        allowedSpecialChars={'all'}
                    />
                </div>
                {!hideUom &&
                    <div className='im-flex-row-item' style={{ width: "150px" }}>
                        <NbisCommonField
                            errorMessages={{}}
                            isReadOnly={false}
                            isShowOptional={false}
                            readOnlyValue={chargeBatchUpdate.chargeUom ?? ""}
                            fieldValue={chargeBatchUpdate.chargeUom}
                            fieldLabel={"Charge Qty UOM"}
                            isSaveClicked={false}
                            fieldType={FieldType.DROPDOWN}
                            fieldKey={'chargeUom'}
                            options={uomDropdownOption}
                            requiredFieldList={[]}
                            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                    </div>}
            </div>
        </>
    )
}